<template>
  <div class="flex flex-col">
    <ComplexFilter
      v-model="filterModel"
      :own-fields="fieldOptions"
      :disabled="disabled"
      partner-mode="none"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComplexFilter, {
  type ComplexFilterOutput,
} from '@/components/filters/ComplexFilter.vue';
import type { FilterGroupOutput } from '@/components/filters/ComplexFilterSection.vue';
import type { GroupedFieldOption } from '@/components/filters/types';

defineProps<{
  fieldOptions: GroupedFieldOption[];
  disabled?: boolean;
}>();

const filterGroups = defineModel<FilterGroupOutput[]>({ default: () => [] });

// Simple wrapper - ComplexFilter expects { ownGroups } shape
const filterModel = computed<ComplexFilterOutput | null>({
  get: () =>
    filterGroups.value.length ? { ownGroups: filterGroups.value } : null,
  set: (val) => {
    filterGroups.value = val?.ownGroups ?? [];
  },
});
</script>

<style lang="pcss">
/* Ensure filter dropdowns appear above the modal (z-index 1000) */
.c-bitts-dropdown-menu__popover.ant-popover,
.bitts-filter-multiselect__popover.ant-popover {
  @apply z-[1050] max-w-[600px];
}
</style>
